export const queryKeys = {
  dashboard: {
    all: ['dashboard'],
  },
  organizations: {
    all: ['organizations'],
    list: (filters) => ['organizations', 'list', filters],
    detail: (id) => ['organizations', id],
    users: (id) => ['organizations', id, 'users'],
    contracts: (id, filters) => ['organizations', id, 'contracts', filters],
    branches: (id) => ['organizations', id, 'branches'],
  },
  onboarding: {
    all: ['onboarding'],
    list: (filters) => ['onboarding', 'list', filters],
    detail: (id) => ['onboarding', id],
  },
  users: {
    all: ['users'],
    list: (filters) => ['users', 'list', filters],
    detail: (id) => ['users', id],
    orgUsers: (orgId, filters) => ['users', 'org', orgId, filters],
    sessions: (id) => ['users', id, 'sessions'],
    globalSessions: (filters) => ['sessions', 'list', filters],
  },
  roles: {
    all: ['roles'],
    list: (filters) => ['roles', 'list', filters],
    permissions: ['roles', 'permissions'],
  },
  settings: {
    all: ['settings'],
    featureFlags: ['settings', 'feature-flags'],
    lookups: ['settings', 'lookups'],
  },
  audit: {
    all: ['audit'],
    list: (filters) => ['audit', 'list', filters],
    entity: (entityType, entityId, filters) => ['audit', 'entity', entityType, entityId, filters],
  },
  contracts: {
    all: ['contracts'],
    list: (filters) => ['contracts', 'list', filters],
    detail: (contractNumber) => ['contracts', contractNumber],
    timeline: (id) => ['contracts', id, 'timeline'],
    lineItems: (id) => ['contracts', id, 'line-items'],
    documents: (id) => ['contracts', id, 'documents'],
  },
  catalog: {
    all: ['catalog'],
    list: (filters) => ['catalog', 'list', filters],
    flagged: (filters) => ['catalog', 'flagged', filters],
    detail: (id) => ['catalog', id],
  },
  announcements: {
    all: ['announcements'],
    list: (filters) => ['announcements', 'list', filters],
    detail: (id) => ['announcements', id],
  },
  reports: {
    all: ['reports'],
    topSuppliers: (filters) => ['reports', 'top-suppliers', filters],
    onboardingFunnel: (filters) => ['reports', 'onboarding-funnel', filters],
    overview: (filters) => ['reports', 'overview', filters],
    gmv: (filters) => ['reports', 'gmv', filters],
    disputeRate: (filters) => ['reports', 'dispute-rate', filters],
  },
  deliveries: {
    all: ['deliveries'],
    list: (filters) => ['deliveries', 'list', filters],
    detail: (id) => ['deliveries', id],
    timeline: (id) => ['deliveries', id, 'timeline'],
  },
  invoices: {
    all: ['invoices'],
    list: (filters) => ['invoices', 'list', filters],
    summary: (filters) => ['invoices', 'summary', filters],
    detail: (id) => ['invoices', id],
  },
  payments: {
    all: ['payments'],
    list: (filters) => ['payments', 'list', filters],
    summary: (filters) => ['payments', 'summary', filters],
    detail: (id) => ['payments', id],
  },
  installments: {
    all: ['installments'],
    list: (filters) => ['installments', 'list', filters],
  },
  disputes: {
    all: ['disputes'],
    list: (filters) => ['disputes', 'list', filters],
    summary: (filters) => ['disputes', 'summary', filters],
    detail: (id) => ['disputes', id],
    timeline: (id) => ['disputes', id, 'timeline'],
    documents: (id) => ['disputes', id, 'documents'],
  },
  messages: {
    all: ['messages'],
    list: (filters) => ['messages', 'list', filters],
    detail: (id) => ['messages', id],
    messages: (id, filters) => ['messages', id, 'messages', filters],
  },
  support: {
    all: ['support'],
    tickets: (filters) => ['support', 'tickets', filters],
    ticket: (id) => ['support', 'tickets', id],
    faq: ['support', 'faq'],
  },
  subscriptions: {
    all: ['subscriptions'],
    list: (filters) => ['subscriptions', 'list', filters],
    plans: () => ['subscriptions', 'plans'],
    org: (orgId) => ['subscriptions', 'org', orgId],
  },
};
